exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.mp-query-sampling-cta {\n  align-items: center;\n  color: var(--primary-text-color);\n  display: flex;\n  flex-direction: column;\n  height: 64px;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: 10px 0;\n  transition: opacity 0.2s ease;\n}\n", ""]);

// exports
